import mitt from 'mitt'
import type { ShareBetData } from '@core/Areas/ShareBet/types'

export const shareManagerEmitter = mitt<{
  openShareOutgoing: ShareBetData
}>()

export const openShareOutgoing = (share: ShareBetData) =>
  shareManagerEmitter.emit('openShareOutgoing', share)
